export default __webpack_public_path__ + "static/media/triangles-no-2.9e9b9763.ogg";